

export class DistriMagasinLivrer {
    
    nomMagasin : string;
    idMagasin : number;
    loginGerant : string;
    nomsGerant : string;

    constructor() { }
}
